import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart, Stamp } from "lucide-react";
import { api } from "../lib/api";
import { useFavorites } from "../hooks/useFavorites";
import { useAuth } from "../context/AuthContext";
import { TruckCard } from "../components/TruckCard";
import { TruckGridSkeleton } from "../components/TruckCardSkeleton";
import { Button } from "../components/ui/button";

export default function Favorites() {
  const { favs } = useFavorites();
  const { user } = useAuth();
  const [trucks, setTrucks] = useState([]);
  const [loyalty, setLoyalty] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/trucks").then((r) => setTrucks(r.data.results.filter((t) => favs.includes(t.slug)))).finally(() => setLoading(false));
  }, [favs]);
  useEffect(() => { if (user) api.get("/me/loyalty").then((r) => setLoyalty(r.data)).catch(() => {}); }, [user]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10">
      <h1 className="text-3xl sm:text-4xl font-display font-extrabold text-urban-teal flex items-center gap-2"><Heart className="fill-coral-twist text-coral-twist" /> Mes favoris</h1>
      <p className="text-urban-teal/60 mt-1">Vos foodtrucks préférés, à retrouver en un tap.</p>

      {user && loyalty.length > 0 && (
        <div className="bg-white rounded-2xl shadow-warm p-5 mt-6" data-testid="loyalty-list">
          <p className="font-display font-bold text-urban-teal flex items-center gap-2 mb-3"><Stamp size={18} className="text-street-gold" /> Mes tampons de fidélité</p>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {loyalty.map((l) => (
              <Link key={l.slug} to={`/foodtruck/${l.slug}`} className="border-2 border-cream-bg rounded-xl p-3 hover:border-street-gold transition-colors">
                <div className="flex items-center justify-between"><span className="font-bold text-urban-teal">{l.name}</span><span className="text-xs text-urban-teal/50">{l.stamps}/{l.threshold}</span></div>
                <div className="flex gap-1 mt-2">{Array.from({ length: l.threshold }).map((_, i) => <span key={i} className={`h-2 flex-1 rounded-full ${i < l.progress ? "bg-street-gold" : "bg-cream-bg"}`} />)}</div>
                {l.rewards > 0 && <p className="text-xs font-bold text-fresh-mint mt-2">{l.rewards} récompense(s) gagnée(s) !</p>}
              </Link>
            ))}
          </div>
        </div>
      )}

      {loading ? (
        <TruckGridSkeleton count={4} />
      ) : trucks.length === 0 ? (
        <div className="text-center py-16" data-testid="favorites-empty">
          <Heart size={48} className="text-urban-teal/20 mx-auto" />
          <p className="font-display font-bold text-xl text-urban-teal mt-4">Aucun favori pour l'instant</p>
          <p className="text-urban-teal/60 mt-2">Touchez le cœur sur un foodtruck pour l'ajouter ici.</p>
          <Button asChild className="rounded-full bg-street-gold text-white font-bold mt-5"><Link to="/recherche">Explorer les foodtrucks</Link></Button>
        </div>
      ) : (
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4 mt-6">
          {trucks.map((t, i) => <TruckCard key={t.slug} truck={t} index={i} />)}
        </div>
      )}
    </div>
  );
}
